import i18n from '@lib/i18n';
import { useMemo } from 'react';

export default function useI18n(path) {
    return useMemo(() => i18n(path), [path]);
}
